import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { toBuilderGlobalId } from './globalId'

// One dashboard: its grid ("Dashboard"), its name and audience
// ("Configuration"), like a Metabase dashboard's two tabs, and its saved
// versions ("History", editors only).
export const createBuilderDetailViewRoutesMap = (prefix: string) => ({
  dashboard: pathJoin(prefix)('dashboard').chain,
  configuration: pathJoin(prefix)('configuration').chain,
  history: pathJoin(prefix)('history').chain,
})

// Data & Analytics › New dashboards (ui.analytics.dashboard_builder).
// `new` is a literal segment: route it before `:id`.
export const createBuilderRoutesMap = (prefix: string) => ({
  ':id': (id = ':id') =>
    pathJoin(prefix)(toBuilderGlobalId(id)).chainMapAuto(
      createBuilderDetailViewRoutesMap,
      {
        title: <T _str="Dashboard" />,
        breadCrumbTitle: <T _str="Dashboard" />,
      }
    ),
  new: pathJoin(prefix)('new').chainWithTitle({
    title: <T _str="Create dashboard" />,
    breadCrumbTitle: <T _str="Create" />,
  }),
})
